import { Card } from '@ipfabric/ui-components/Card/Card';
import type { ReactNode } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { PrivilegedCredentialsFieldValues } from '../../snippets/storedPrivilegedCredentials';
import { SearchableSection } from '../DiscoverySearch/SearchableSection';

type Props = {
  form: UseFormReturn<PrivilegedCredentialsFieldValues>;
  renderSnippet: (name: 'storedPrivilegedCredentials') => ReactNode;
};

export const PrivilegedCredentials = (props: Props) => (
  <Card className='flex flex-col flex-1 rounded-tl-none' noShadow>
    <SearchableSection
      id='privileged-credentials'
      className='flex flex-col flex-1 p'
      wrapperClassName='flex flex-col flex-1'
    >
      {props.renderSnippet('storedPrivilegedCredentials')}
    </SearchableSection>
  </Card>
);
